'use client'

import React from 'react'
import classnames from 'classnames'

import {PromoCard} from '../../../ui/cards/PromoCard'
import {THeaderProps} from '../../index'
import {AppBlock} from '../AppBlock'
import {ExtraBlock} from '../ExtraBlock'
import {LinkList} from '../LinkList'
import {Switcher} from '../Switcher'

import extraBlockStyles from '../ExtraBlock/styles.module.css'
import styles from './styles.module.css'

type TExpandedHeaderProps = Pick<THeaderProps, 'navigation'> & {
  activeLinkIndex: number
  setMenuSwitcherIndex: (index: number) => void
}

export function Expanded({navigation, activeLinkIndex, setMenuSwitcherIndex}: TExpandedHeaderProps) {
  const {info = [], app, extra, promo} = navigation[activeLinkIndex]
  const [info1, info2] = info

  return (
    <div className={styles.expandedMenuContainer} onClick={event => event.stopPropagation()}>
      <div className={styles.expandedMenu}>
        <Switcher
          navigation={navigation}
          activeLinkIndex={activeLinkIndex}
          onChangeTab={setMenuSwitcherIndex}
          className={styles.expandedSwitcherMobile}
        />

        <div className={styles.blocksContainer}>
          <div className={styles.leftContainer}>
            {info1 && <LinkList caption={info1.caption} items={info1.items} className={styles.block} />}
            {app && <AppBlock {...app} className={styles.block} />}
          </div>
          {(info2 || extra) && (
            <div className={styles.rightContainer}>
              {info2 && <LinkList caption={info2.caption} items={info2.items} className={styles.block} />}
              {extra && (
                <ExtraBlock {...extra} className={classnames(extraBlockStyles.extraBlockDesktop, styles.block)} />
              )}
            </div>
          )}
        </div>
        {promo && <PromoCard {...promo} />}
        {extra && (
          <ExtraBlock
            {...extra}
            className={classnames(extraBlockStyles.extraBlockMobile, styles.block, {
              [extraBlockStyles.withPromo]: promo,
            })}
          />
        )}
      </div>
    </div>
  )
}
